import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';
import AuthImage from 'assets/Branding/fondo.jpg';

export const useStyles = makeStyles((theme: Theme) => ({
  expiredContainer: {
    textAlign: 'center',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${AuthImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  expiredLogo: {
    width: '350 px',
    marginBottom: theme.spacing(3),
  },
  divider: {
    width: '80%',
    margin: theme.spacing(3, 0),
    backgroundColor: '#ffffff',
  },
  textSecondaryColor: {
    color: '#ffffff',
    textShadow: '1px 1px 3px rgba(0, 0, 0, 0.8)',
    fontSize: '16px',
  },
  whatsappButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5, 4),
    fontWeight: 'bold',
    backgroundColor: '#25D366', // Color de WhatsApp
    color: 'white',
    '&:hover': {
      backgroundColor: '#128C7E',
    },
  },
}));
